import React, { useState } from "react";
import { Group, Text } from "@mantine/core";

interface DateRangeProps {
  onChange: (startDate: string, endDate: string) => void;
}

const DateRangePicker: React.FC<DateRangeProps> = ({ onChange }) => {
  const today = new Date();
  const todayStr =
    new Date().getFullYear() +
    "-" +
    String(today.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(today.getDate()).padStart(2, "0"); // Get today's date in YYYY-MM-DD format

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newStartDate = e.target.value;
    setStartDate(newStartDate);

    // Ensure start date is not after end date
    if (newStartDate > endDate) {
      setEndDate(newStartDate);
      onChange(newStartDate, newStartDate);
    } else {
      onChange(newStartDate, endDate);
    }
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEndDate = e.target.value;
    setEndDate(newEndDate);

    // Ensure end date is not before start date
    if (newEndDate < startDate) {
      setStartDate(newEndDate);
      onChange(newEndDate, newEndDate);
    } else {
      onChange(startDate, newEndDate);
    }
  };

  return (
    <Group>
      <label>
        <Text span fw={700} me="sm">
          From:
        </Text>
        <input
          type="date"
          value={startDate}
          max={todayStr} // Restrict max date to today
          onChange={handleStartDateChange}
          className="date-picker-input"
        />
      </label>
      <div></div>
      <label>
        <Text span fw={700} me="sm">
          To:
        </Text>
        <input
          type="date"
          value={endDate}
          min={startDate} // Restrict min date to startDate
          max={todayStr} // Restrict max date to today
          onChange={handleEndDateChange}
          className="date-picker-input"
        />
      </label>
    </Group>
  );
};

export default DateRangePicker;
